import React, { PureComponent } from 'react';
import { Button, Grid, Typography } from '@material-ui/core';
import { MyPATTextField } from '../../../../../common';
import MyPATCalendar from '../../../../../common/MyPATCalendar';
import TimeInput from 'material-ui-time-picker';

interface AddNewTestProps {
  classes: any;
  handleFormChange: Function;
  handleSubmit: React.MouseEventHandler<HTMLElement>;
  handleStartDate: Function;
  handleStartTime: Function;
  handleEndTime: Function;
  handleEndDate: Function;
  isDateRangeValid: Function;
  maxDate: Date;
  minDate: Date;
  test: {
    name: string;
    startDate: Date;
    startTime: Date;
    endDate?: Date | 'NA';
    endTime?: Date;
    maxAttempts: Number | string;
    syllabus: string;
    duration: Number | string;
    error: string;
    dateError: string;
  };
}

export default class AddNewTest extends PureComponent<AddNewTestProps> {
  getMinDate = () => {
    const date = new Date(this.props.test.startDate);
    return new Date(date.setDate(date.getDate() + 1));
  };

  render() {
    const {
      classes,
      handleFormChange,
      handleSubmit,
      test,
      handleEndDate,
      handleStartDate,
      isDateRangeValid,
      handleStartTime,
      maxDate,
      minDate,
      handleEndTime,
    } = this.props;
    const { name, startDate, endDate, maxAttempts, syllabus, duration, error, dateError } = test;
    // console.log(startDate, endDate);
    return (
      <>
        <MyPATTextField
          label='Test name'
          required
          inputId='testName'
          fullWidthControl
          fullWidthInput
          name='name'
          value={name}
          onChange={handleFormChange}
        />

        <MyPATTextField
          label='Syllabus'
          required
          id='outlined-bare'
          fullWidthControl
          fullWidthInput
          fullWidth={true}
          margin='normal'
          variant='outlined'
          name='syllabus'
          value={syllabus}
          onChange={handleFormChange}
        />
        <div>
          <Typography className={classes.inputLable}>
            Start Date<span className={classes.colorRed}>*</span>
          </Typography>
          <span>
            <MyPATCalendar onChange={handleStartDate} date={startDate} minDate={minDate} maxDate={maxDate} />
            <span>
              <TimeInput mode='12h' value={new Date(startDate)} onChange={handleStartTime} />
            </span>
          </span>
          {/* </Grid> */}
        </div>
        {endDate !== 'NA' && endDate ? (
          <div>
            {/* <Grid item className={classes.MyPATCalendarUi}> */}
            <Typography className={classes.inputLable}>
              End Date<span className={classes.colorRed}>*</span>
            </Typography>
            <span>
              <MyPATCalendar onChange={handleEndDate} date={endDate} minDate={this.getMinDate()} maxDate={maxDate} />
              <span>
                <TimeInput mode='12h' value={new Date(endDate)} onChange={handleEndTime} />
              </span>
            </span>
            {/* </Grid> */}
          </div>
        ) : (
          <></>
        )}
        {/* <MyPATTextField
          label='Start Date &amp; Time'
          required
          id='outlined-bare'
          fullWidthControl
          fullWidthInput
          type='datetime-local'
          fullWidth={true}
          variant='outlined'
          name='startDate'
          value={startDate.toISOString().substring(0, startDate.toISOString().length - 8)}
          onChange={handleFormChange}
          InputLabelProps={{
            shrink: true,
          }}
        />

        {endDate !== 'NA' ? (
          <MyPATTextField
            label='End Date &amp; Time'
            required
            disabled={endDate ? false : true}
            id='outlined-bare'
            fullWidthControl
            fullWidthInput
            type='datetime-local'
            variant='outlined'
            fullWidth={true}
            name='endDate'
            value={
              endDate ? endDate.toISOString().substring(0, endDate.toISOString().length - 8) : new Date().toISOString()
            }
            onChange={handleFormChange}
            InputLabelProps={{
              shrink: true,
            }}
          />
        ) : (
          <></>
        )} */}

        <MyPATTextField
          label='Max Attempts'
          required
          id='outlined-bare'
          fullWidthControl
          fullWidthInput
          fullWidth={true}
          margin='normal'
          variant='outlined'
          name='maxAttempts'
          value={maxAttempts + ''}
          onChange={handleFormChange}
        />

        <MyPATTextField
          label='Duration'
          required
          id='outlined-bare'
          fullWidthControl
          fullWidthInput
          fullWidth={true}
          margin='normal'
          variant='outlined'
          name='duration'
          value={duration + ''}
          onChange={handleFormChange}
          placeholder='Minutes'
        />

        <p className={classes.colorRed}>{error || dateError}</p>
        <Button variant='contained' color='primary' onClick={handleSubmit} disabled={!isDateRangeValid()}>
          Submit
        </Button>
      </>
    );
  }
}
